__turbopack_context__.v({
  "className": "geist_e37abe8e-module__ohaI6G__className",
  "variable": "geist_e37abe8e-module__ohaI6G__variable",
});
